<script>
  import { onDestroy, onMount } from "svelte";
  import { navigateTo } from "svelte-router-spa";
  import { _ } from "svelte-i18n";

  onMount(() => {});
</script>

<div class="a-contents-refer">
  <div class="event-title">
    <div class="e-title svelte-7g24w">
      <strong class="bold-text-7">{$_("project.index.1_1")}</strong>
    </div>
  </div>
  <div class="use-case-reference">
    <div class="div-block-66">
      <div class="use-case-reference-wrap">
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d54d-05240443"
          class="reference"
        >
          <img
            src="/static/images/screencast_93.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/fsv057730s"
            target="_blank"
            class="link-28">몰랑이가 살아났다!</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d54d-05240443"
          class="reference"
        >
          <img
            src="/static/images/screencast_79.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/osb3w03gl2"
            target="_blank"
            class="link-28">깨꾸가 살아났다!</a
          >
        </div>
        <div
          id="w-node-_91304d8d-d465-aa63-d3be-607fc0eb8319-05240443"
          class="reference"
        >
          <img
            src="/static/images/screencast_83.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/@chuseok"
            target="_blank"
            class="link-28">그냥이의 고향송편 만들기!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_24.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/lyjjdqp0ls"
            target="_blank"
            class="link-28">먼지가 살아났다!</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d525-05240443"
          class="reference"
        >
          <img
            src="/static/images/screencast_58.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/@koreanhistory"
            target="_blank"
            class="link-28">한국사쌤의 비밀교실</a
          >
        </div>
        <div
          id="w-node-_2951cbe4-c4af-ab76-544c-faeb7c9a685a-05240443"
          class="reference"
        >
          <img
            src="/static/images/화면-기록-2024-03-14-오후-4.23.03-2.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/urgkf5deyi"
            target="_blank"
            class="link-28">우주러너 MBTI 테스트</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/ava-case3.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/z2v636jcnl"
            target="_blank"
            class="link-28">쫀댕이가 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/ava-case5.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/wmf013yr7d"
            target="_blank"
            class="link-28">킬러알비가 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/ava-case6.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/q870batav8"
            target="_blank"
            class="link-28">밀리지가 살아났다!</a
          >
        </div>
      </div>
      <div class="use-case-reference-wrap">
        <div class="reference">
          <img
            src="/static/images/screencast_88.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a href="https://avatalk.in/view/bhm68vcr47" class="link-28"
            >아찌와하찌가 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_65.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/ix8ewu2n3c"
            target="_blank"
            class="link-28">퍼킹햄이 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_70.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/zoc6p1awhg"
            target="_blank"
            class="link-28">불편해요, 선배님! 웹툰 아바톡</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_54.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/h4j4u78jmr"
            target="_blank"
            class="link-28">꽃찌가 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_50.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/80ro49jlpk"
            target="_blank"
            class="link-28">별자리 운세</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d52e-05240443"
          class="reference"
        >
          <img
            src="/static/images/화면-기록-2024-03-14-오후-4.25.29-1.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/iu0rh7lic2"
            target="_blank"
            class="link-28">나는 어떤 그냥이일까?</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/ava-case12.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/jqm3vljdy"
            target="_blank"
            class="link-28">야우가 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/daggi.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/zuo6yqeqc6"
            target="_blank"
            class="link-28">떼기가 살아났다!</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d532-05240443"
          class="reference"
        >
          <img
            src="/static/images/ava-case10.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/49opq4t2g5"
            target="_blank"
            class="link-28">스마일곰씨가 살아났다!</a
          >
        </div>
      </div>
    </div>
    <div class="div-block-67">
      <div class="use-case-reference-wrap">
        <div class="reference">
          <img
            src="/static/images/screencast_96.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/evrraewsmx"
            target="_blank"
            class="link-28">무모와 대화하기!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_75.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/xh1fuoitvn"
            target="_blank"
            class="link-28">소원선배와 대화하기!</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d521-05240443"
          class="reference"
        >
          <img
            src="/static/images/screencast_69.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/m9hv8yti57"
            target="_blank"
            class="link-28"
            >코코몽이 살아났다!
          </a>
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_82.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/@halloween"
            target="_blank"
            class="link-28">그냥이의 할로원 퀴즈!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_32.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/pir09u1j8b"
            target="_blank"
            class="link-28">라라부가 살아났다!</a
          >
        </div>
        <div
          id="w-node-afbc819a-d39d-9050-f8b9-39bfe1228604-05240443"
          class="reference"
        >
          <img
            src="/static/images/screencast_49.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/j0wtsxjkg8"
            target="_blank"
            class="link-28">그냥이가 써주는 편지!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_27.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/0jlqxknxug"
            target="_blank"
            class="link-28">라빗이 살아났다!</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d540-05240443"
          class="reference"
        >
          <img
            src="/static/images/ava-case13.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/povan2ih3h"
            target="_blank"
            class="link-28">포시러브가 살아났다!</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d544-05240443"
          class="reference"
        >
          <img
            src="/static/images/ava-case9.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/xnjvk154yz"
            target="_blank"
            class="link-28">소녀A가 살아났다!</a
          >
          <a
            href="https://avatalk.in/view/xnjvk154yz"
            target="_blank"
            class="link-28">소녀A가 살아났다!</a
          >
        </div>
      </div>
      <div class="use-case-reference-wrap last">
        <div class="reference">
          <img
            src="/static/images/screencast_98.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/qwr2ch9a6h"
            target="_blank"
            class="link-28">클로버니가 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_100.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/e316cev7l2"
            target="_blank"
            class="link-28">빈둥이 아바톡!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_67.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/7epo3npt5n"
            target="_blank"
            class="link-28">삐앙이가 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_76.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/o5j5fcdjkz"
            target="_blank"
            class="link-28">군인공제회 아바톡!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/screencast_56.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/@mathclass"
            target="_blank"
            class="link-28">수학쌤의 깜짝교실!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/화면-기록-2024-03-14-오후-4.25.04.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/91cltn9udc"
            target="_blank"
            class="link-28">오늘 점심 뭐먹지?</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/ava-case11.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/57obgx1122"
            target="_blank"
            class="link-28">햄몽이 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/ava-case7.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/3fgpfx4buj"
            target="_blank"
            class="link-28">피찌가 살아났다!</a
          >
        </div>
        <div
          id="w-node-_3ca105c8-7e06-0042-f613-73ca8c85d551-05240443"
          class="reference"
        >
          <img
            src="/static/images/ava-case8.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/yl3oy6ynoo"
            target="_blank"
            class="link-28">하트쿵이 살아났다!</a
          >
        </div>
        <div class="reference">
          <img
            src="/static/images/ava-case14.gif"
            loading="lazy"
            width="260"
            alt=""
            class="use-case-reference-con"
          />
          <a
            href="https://avatalk.in/view/4kwqf4bzp8"
            target="_blank"
            class="link-28">까시가 살아났다!</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="ava-con8">
  <h1 class="a-h1 white">{$_("project.index.44")}</h1>
  <div class="div-block-70">
    <div class="div-block-71">
      <img
        src="https://uploads-ssl.webflow.com/643fa5ea1edc7d4b4f73346a/643fa5ea1edc7d060d73367a_check.svg"
        loading="lazy"
        alt=""
        class="image-140"
      />
      <div class="text-block-78">{$_("project.index.45")}</div>
    </div>
    <div class="div-block-71">
      <img
        src="https://uploads-ssl.webflow.com/643fa5ea1edc7d4b4f73346a/643fa5ea1edc7d060d73367a_check.svg"
        loading="lazy"
        alt=""
        class="image-140"
      />
      <div class="text-block-78">{$_("project.index.46")}</div>
    </div>
    <div class="div-block-71">
      <img
        src="https://uploads-ssl.webflow.com/643fa5ea1edc7d4b4f73346a/643fa5ea1edc7d060d73367a_check.svg"
        loading="lazy"
        alt=""
        class="image-140"
      />
      <div class="text-block-78">{$_("project.index.47")}</div>
    </div>
  </div>
  <div class="a-avatalk _2">
    <a
      href="#"
      class="a-cta-avatalk-2 w-button"
      on:click={() => navigateTo("/join")}>{$_("project.index.48")}</a
    >
  </div>
</div>

<style>
  .use-case-reference {
    background-image: none;
  }

  .a-contents-refer {
    position: relative;
    margin-right: auto;
    margin-left: auto;
    max-width: 1400px;
    margin-top: 110px;
    padding: 0px 20px;
  }

  .event-title {
    margin: auto;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 16px;
  }

  @media screen and (max-width: 1280px) {
    .a-contents-refer {
      margin-top: 100px;
    }
  }

  @media screen and (max-width: 767px) {
    .a-contents-refer {
      margin-top: 76px;
    }
  }

  @media screen and (max-width: 479px) {
    .a-contents-refer {
      margin-top: 66px;
    }
    .e-title {
      margin-bottom: 0;
      line-height: 40px;
      font-size: 20px;
      padding-left: 0;
    }
  }
</style>
